import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { ShieldCheck } from 'lucide-react';
import { ipsBloqueadosAPI } from '../../utils/adminSegurancaAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';
import ModalRodape from './ModalRodape';

const ConfirmarDesbloquearIpModal = ({ ip, onFechar, onConfirmado }) => {
  const [enviando, setEnviando] = useState(false);

  const confirmar = async () => {
    setEnviando(true);
    try {
      await ipsBloqueadosAPI.desbloquear(ip.id);
      sucessoComHorario(`IP ${ip.ip} desbloqueado`);
      onConfirmado();
      onFechar();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao desbloquear IP');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3 rounded-xl p-4 bg-emerald-50">
        <ShieldCheck className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-medium text-gray-900 font-mono">{ip.ip}</p>
          <p className="text-gray-600 mt-1">Volta a ter acesso normal às páginas públicas e ao login imediatamente.</p>
        </div>
      </div>

      <ModalRodape>
        <button
          onClick={onFechar}
          className="text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg px-4 py-2.5 transition-colors"
        >
          Cancelar
        </button>
        <button
          onClick={confirmar}
          disabled={enviando}
          className="font-medium text-sm px-4 py-2.5 rounded-lg transition-colors disabled:opacity-50 bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          {enviando ? 'Aguarde...' : 'Desbloquear'}
        </button>
      </ModalRodape>
    </div>
  );
};

export default ConfirmarDesbloquearIpModal;
